export default "__VITE_ASSET__COLBikyB__"